import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux';
import { compareAsc, format } from 'date-fns'
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';

import moment from "moment";
import jwt_decode from 'jwt-decode';
import { attendenace_action } from '../../Redux/Actions/attendance_action';

import { Link } from 'react-router-dom';

import MiniCalendar from './miniCalendar';


function DashboardComp() {
	const dispatch = useDispatch()
	let SERVER_URL = process.env.REACT_APP_API_URL;
	let BASE_URL = process.env.REACT_APP_APP_URL;
	let token = JSON.parse(localStorage.getItem('key'));

	const [user, setUser] = useState();
	const [userbirthday, setUserbirthday] = useState([]);
	const [newslistleft, setNewslistleft] = useState([])
	const [newslist, setNewslist] = useState([])
	const [qbsmoments, setQbsmoments] = useState([]);
	const [userEvent, setUserEvent] = useState([]);
	const [EventDate, setEventDate] = useState(moment().format('DD/MM/YYYY'));
	const [quote, setQuote] = useState('');
	useEffect(() => {
		let carouselTest = document.querySelectorAll("carouselTest")
	}, [])

	const getUserLeavebalance = () => {
		const response = fetch(SERVER_URL + `api/attendance/leave-balance-list`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token.value}`
				},
				// body: JSON.stringify({
				//     id: email
				// }),
			}).then(res => res.json())
			.then(data => {
				setUserbirthday(data.result)
			});
	}


	const date = new Date();
	let date_formate = format(date, 'yyyy-MM-dd')
	const userId = localStorage.getItem('userId');
	const state = {
		emp_id: userId,
		date: date_formate
	}




	const calendar = new MiniCalendar();
	calendar.onDateClick = function (e) {

	};
	// calendar.onEventInMonthClick = function (e) {

	// };
	calendar.onEventTextInMonthClick = function (SelectedDate) {
		const SERVER_URL = process.env.REACT_APP_API_URL;
		const token = JSON.parse(localStorage.getItem('key'));
		const Day = moment(SelectedDate).format('DD');
		const Year = moment(SelectedDate).format('YYYY');
		const Month = moment(SelectedDate).format('MM');
		//  console.log('day_'+Day)
		//  console.log('Year_'+Year)
		// console.log('month_'+month)
		// console.log('year_'+year)
		// console.log('SERVER_URL_'+SERVER_URL)
		//console.log(token.value)
		const response = fetch(SERVER_URL + `api/holiday/office-holiday-selected-day`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token?.value}`
				},
				body: JSON.stringify({ month: Month, day: Day, year: Year }),
			}).then(res => res.json())
			.then(data => {

				setUserEvent(data.result[0] ? data.result[0].level : []);
				setEventDate(SelectedDate ? moment(SelectedDate).format('DD/MM/YYYY') : '');
			});

	};
	calendar.getDayWishBirthday = function (SelectedDate) {
		const SERVER_URL = process.env.REACT_APP_API_URL;
		const token = JSON.parse(localStorage.getItem('key'));
		//  console.log('day_'+SelectedDate)
		// console.log('month_'+month)
		// console.log('year_'+year)
		// console.log('SERVER_URL_'+SERVER_URL)
		//console.log(token.value)
		const response = fetch(SERVER_URL + `api/employee/birthday`,
			{
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'authorization': `bearer ${token?.value}`
				},
				body: JSON.stringify({ date: SelectedDate }),
			}).then(res => res.json())
			.then(data => {
				setUserbirthday(data.result)
			});

	};
	//console.log('calendar')
	//console.log(calendar);
	function setCalendarContainers() {
		calendar.setCalenderContainer(document.querySelector('#calendar'));
		calendar.setHeaderTextElement(document.querySelector("#headerText"));
	}


	function onPrev() {
		setCalendarContainers();
		calendar.prev();
		// alert()
	}

	function onNext() {
		setCalendarContainers();
		calendar.next();
	}

	function onToday() {
		setCalendarContainers();
		calendar.goToToday()
	}

	useEffect(() => {
		setCalendarContainers();
	}, [])

	useEffect(() => {
		const gettoken = localStorage.getItem('key');
		const token_data = jwt_decode(gettoken);
		setUser(token_data.name)
	}, [])



	useEffect(() => {
		dispatch(attendenace_action(state))
	}, [])



	const [error, setError] = useState(null);
	const controller = new AbortController();
	const signal = controller.signal; // The signal that we will pass to the fetch request

	useEffect(() => {
		const getMoments = async () => {
			try {
				const response = await fetch(SERVER_URL + `api/moments`,
					{
						method: 'GET',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'authorization': `bearer ${token.value}`
						},
						signal: signal
					});
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const result = await response.json();
				if (result.status == true) {
					setQbsmoments(result.result)
				}
			} catch (err) {
				if (err.name === 'AbortError') {
					console.log('Fetch request was aborted');
				} else {
					setError(err.message || 'An error occurred');
				}
			}
		}
		getMoments()
		return () => {
			controller.abort(); // This will cancel the fetch request when the component unmounts
		};
	}, [])

	useEffect(() => {
		const getRecentJoin = async () => {
			try {
				const response = await fetch(SERVER_URL + `api/employee/recently-joining`,
					{
						method: 'POST',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'authorization': `bearer ${token.value}`
						},
						signal: signal
					})
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const result = await response.json();
				setRecentjoinylist(result.result)
			} catch (err) {
				if (err.name === 'AbortError') {
					console.log('Fetch request was aborted');
				} else {
					setError(err.message || 'An error occurred');
				}
			}
		}
		getRecentJoin()
		return () => {
			controller.abort(); // This will cancel the fetch request when the component unmounts
		};
	}, [])

	useEffect(() => {
		const getClientFeedback = async () => {
			try {
				const response = await fetch(SERVER_URL + `api/employee/client/dashboard-clientfeedback-suggestion`,
					{
						method: 'GET',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'authorization': `bearer ${token.value}`
						},
						signal: signal
					})
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const result = await response.json();
				if (result.status == true) {
					setClientfeedbacklist(result.client)
				}
			} catch (err) {
				if (err.name === 'AbortError') {
					console.log('Fetch request was aborted');
				} else {
					setError(err.message || 'An error occurred');
				}
			}
		}
		getClientFeedback();
		return () => {
			controller.abort(); // This will cancel the fetch request when the component unmounts
		};
	}, [])



	useEffect(() => {
		const getUserTodaysBirthday = async () => {
			try {
				const response = await fetch(SERVER_URL + `api/employee/birthday`,
					{
						method: 'POST',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'authorization': `bearer ${token.value}`
						}
					})
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const result = await response.json();
				setUserbirthday(result.result)
			} catch (err) {
				if (err.name === 'AbortError') {
					console.log('Fetch request was aborted');
				} else {
					setError(err.message || 'An error occurred');
				}
			}
		}
		getUserTodaysBirthday()
		return () => {
			controller.abort(); // This will cancel the fetch request when the component unmounts
		};
	}, [])


	useEffect(() => {
		const getSingleQuote = async () => {
			try {
				const response = await fetch(SERVER_URL + `api/quote/single-quote`,
					{
						method: 'POST',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'authorization': `bearer ${token.value}`
						}
					})
				const result = await response.json();
				setQuote(result.result?.description)
			} catch (err) {
				if (err.name === 'AbortError') {
					console.log('Fetch request was aborted');
				} else {
					setError(err.message || 'An error occurred');
				}
			}
		}
		getSingleQuote()
		return () => {
			controller.abort(); // This will cancel the fetch request when the component unmounts
		};
	}, [])






	const [recentjoinylist, setRecentjoinylist] = useState([]);

	const [talklist, setTalklist] = useState([])
	const [clientfeedbacklist, setClientfeedbacklist] = useState([])
	useEffect(() => {
		const gettalk = async () => {
			try {
				const response = await fetch(SERVER_URL + `api/employee/talk/dashboard-feedback-suggestion`,
					{
						method: 'GET',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'authorization': `bearer ${token.value}`
						},
						signal: signal
					})
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const result = await response.json();
				if (result.status == true) {
					setTalklist(result.talk)
				}
			} catch (err) {
				if (err.name === 'AbortError') {
					console.log('Fetch request was aborted');
				} else {
					setError(err.message || 'An error occurred');
				}
			}
		}
		gettalk();
		return () => {
			controller.abort(); // This will cancel the fetch request when the component unmounts
		};
	}, [])

	useEffect(() => {
		const getNewsFeedsThree = async () => {
			try {
				const response = await fetch(SERVER_URL + `api/news/dashboard-news-feed`,
					{
						method: 'GET',
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json',
							'authorization': `bearer ${token.value}`
						},
						signal: signal
					})
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				const result = await response.json();
				if (result.status == true) {
					setNewslist(result?.result)
					setNewslistleft(result?.result)
				}
			} catch (err) {
				if (err.name === 'AbortError') {
					console.log('Fetch request was aborted');
				} else {
					setError(err.message || 'An error occurred');
				}
			}

		}
		getNewsFeedsThree()
		return () => {
			controller.abort(); // This will cancel the fetch request when the component unmounts
		};
	}, [])




	let talks = []
	const doSomething = () => {
		if (talklist)
			talks = talklist.map((talk, ind) =>
				<div key={ind} >
					<div className="tips_ttl carouselTest" >
						{talk.title}
						<span className="tips_date">{moment(talk.created_on).format('MMMM Do YYYY')}</span>
					</div>
					<p>{talk.message}</p>
				</div>)
	}
	doSomething()

	let qbsmomentsslide = []
	const get_qbsmoment = () => {
		if (qbsmoments)
			qbsmomentsslide = qbsmoments.map((item, ind) =>
				<div key={ind} >
					<img crossOrigin="anonymous" src={`${SERVER_URL + "moments/" + item?.moment_image}`} alt={item.title} />
					<p className="team_ttl">{item.title}</p>
				</div>
			)
	}
	get_qbsmoment()

	let client_feedback = []
	const get_client_feedback = () => {
		if (clientfeedbacklist)
			client_feedback = clientfeedbacklist.map((feedback, ind) =>
				<div key={ind} >
					<div className="tips_ttl carouselTest" >
						{feedback.title}
						<span className="tips_date">{moment(feedback.created_on).format('MMMM Do YYYY')}</span>
					</div>
					<p>{feedback.message}</p>
				</div>)
	}
	get_client_feedback()



	return (
		<div className="container-fluid">
			<div className="row">
				<div className="col-md-3">
					<div className="dash_ttl">{user ? user : ''}</div>
					<div className="dash_search_wrp search">
						<input type="text" className="" placeholder="Are you looking for something ?" />
						<ul className="results" >
							<li><a href="">Search Result #1</a></li>
							<li><a href="">Search Result #2</a></li>
							<li><a href="">Search Result #3</a></li>
							<li><a href="">Search Result #4</a></li>
						</ul>
						<button className="btn_search"><span className="arrow_right"></span><i className="icon icon-magnifier"></i></button>
					</div>

					<div className="dash_white_box mb20">
						<i className="icon icon-hand dash_hand_icon"></i>
						<div className="dash_white_box_ttl mb20">Who join recently ?</div>
						<div className="dash_image_wrp">
							<div className="dash_image_blk">
								<i className="icon icon-chevron-left"></i>
							</div>
							<div className="dash_image_blk ">
								{
									recentjoinylist?.map((item, ind) => {
										if (item?.gender == 1 || item?.gender == 2) {
											var img_url = '';
											if (item?.gender == 1) {
												var img_url = 'images/m_user.png'
											}
											if (item?.gender == 2) {
												var img_url = 'images/f_user.png'
											}
											// if(item.user_image!='' || item.user_image!=null || item.user_image!=undefined){
											// 	var img_url = 'images/'+item.user_image;
											// }

											return <img key={ind} crossOrigin="anonymous" src={`assets/${img_url}`} />
										}

									})
								}
							</div>
							<div className="dash_image_blk">
								<i className="icon icon-chevron-right"></i>
							</div>
						</div>
						<div className="new_wrp"><i className="icon icon-arrow-down"></i>Are you <span>New</span> ?</div>
						<div className="wp100 text-center"><Link to='/user-directry' className="btn_join">Click Here</Link></div>
					</div>

				</div>
				<div className="col-md-6">
					<div className="dash_slider_wrp mb20 mh325">
						<div className="tab-content">
							{
								newslist?.map((item, ind) => {
									return <div key={ind} className={`dash_slider tab-pane ${ind == 0 ? 'active' : ''}`} id={`tab${item.newsID
										}`}>
										<img crossOrigin="anonymous" src={`${SERVER_URL + 'news/' + item.image}`} />
										<div className="slider_ttl"><span className="arrow_right"></span>{item.title}</div>
									</div>
								})
							}
						</div>
						<div className="dash_slider_listing_wrp">
							<ul role="tablist" className="nav nav-tabs">
								{
									newslistleft?.map((item, ind) => {

										return <li key={ind} className="dash_slider_listing_blk">
											<a href={`#tab${item.newsID}`} className={`${ind == 0 ? 'active' : ''}`} data-bs-toggle="tab">
												<div className="das_slider_ttl">{item.title}</div>
												<div className="das_slider_date">{moment(item.createdDate).format('DD/MM/YYYY')}</div>
												<p>{item.remark.substring(0, 65)}...</p>
											</a>
										</li>
									})
								}
							</ul>
							<div className="dash_grey_bg">
								<Link to="/dashboard" className="btn_whitebox">All News <i className="fa fa-angle-double-right"></i></Link>
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-3">
					<div className="dash_white_box1 pb30 mh325 mb20 linkedin_dots" style={{ flex: 1 }}>
						<div className="dash_white_box_ttl1">LinkedIn </div>
						<span className="dash_linkendin_icon"><i className="fa fa-linkedin"></i></span>

						{qbsmomentsslide.length && <Carousel infiniteLoop itemsToShow={1} showThumbs={false} interval={3000} >
							<div className="dash_linkedin_wrp">
								<div className="dash_linkedin_img">
									<div className='post_detail'>
										<img crossOrigin="anonymous" src="assets/images/post.jpg" />
									</div>
									<div className='post_content'>
										<span>QBS Learning</span>
										<span>8,213 followers</span>
									</div>
								</div>
								<div className="dash_linkedin_blk">
									<p className="mb10">The three-day journey has concluded, and QBS Learning had a great time at Bett Global. Engaging conversations and Fun chat with folks in EdTech made it a memorable experience.</p>
									<div className="row">
										<div className="col-md-6 pr07">
											<img crossOrigin="anonymous" src="assets/images/post1.jpg" />
										</div>
										<div className="col-md-6 pl07">
											<img crossOrigin="anonymous" src="assets/images/post2.jpg" />
										</div>
									</div>
								</div>
							</div>
							<div className="dash_linkedin_wrp">
								<div className="dash_linkedin_img">
									<div className='post_detail'>
										<img crossOrigin="anonymous" src="assets/images/post.jpg" />
									</div>
									<div className='post_content'>
										<span>QBS Learning</span>
										<span>8,213 followers</span>
									</div>
								</div>
								<div className="dash_linkedin_blk">
									<p className="mb10"> Unlock the full potential of your assessment programs with our expert-driven, data-informed solutions at QBS Learning. </p>
									<div className="row">
										<div className="col-md-6 pr07">
											<img crossOrigin="anonymous" src="assets/images/post3.jpg" />
										</div>
										<div className="col-md-6 pl07">
											<img crossOrigin="anonymous" src="assets/images/post4.jpg" />
										</div>
									</div>
								</div>
							</div>
							<div className="dash_linkedin_wrp">
								<div className="dash_linkedin_img">
									<div className='post_detail'>
										<img crossOrigin="anonymous" src="assets/images/post.jpg" />
									</div>
									<div className='post_content'>
										<span>QBS Learning</span>
										<span>8,213 followers</span>
									</div>
								</div>
								<div className="dash_linkedin_blk">
									<p className="mb00">
										<strong>Happy Republic Day from QBS Learning!</strong>
									</p>
									<p className="mb10">
										On this momentous occasion, we salute the spirit of unity, diversity, and freedom that defines our great nation.
									</p>
									<div className="row">
										<div className="col-md-6 pr07">
											<img crossOrigin="anonymous" src="assets/images/post5.jpg" />
										</div>
										<div className="col-md-6 pl07">
											<img crossOrigin="anonymous" src="assets/images/post6.jpg" />
										</div>
									</div>
								</div>
							</div>
							<div className="dash_linkedin_wrp">
								<div className="dash_linkedin_img">
									<div className='post_detail'>
										<img crossOrigin="anonymous" src="assets/images/post.jpg" />
									</div>
									<div className='post_content'>
										<span>QBS Learning</span>
										<span>8,213 followers</span>
									</div>
								</div>
								<div className="dash_linkedin_blk">
									<p className="mb10">
										Ramadan Mubarak! QBS Learning wishes you a time filled with productivity, success, and fulfillment.
									</p>
									<div className="row">
										<div className="col-md-12">
											<img crossOrigin="anonymous" src="assets/images/post7.png" />
										</div>
									</div>
								</div>
							</div>
						</Carousel>}
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-md-3">
					<div className="dash_white_box mb20" style={{ minHeight: "unset" }}>
						<i className="fa fa-lightbulb-o dash_bulb_icon"></i>
						<div className="dash_white_box_ttl">Quote of the day</div>
						<p className='relative fs15'><span className="qoute_left"><i className="fa fa-quote-left"></i></span>{quote}<span className="qoute_down"><i className="fa fa-quote-right"></i></span></p>
						<button className="btn_whitebox">All Quote <i className="fa fa-angle-double-right"></i></button>
					</div>
					<div className="team_wrp mb20" style={{ flex: 1 }}>
						{qbsmomentsslide.length && <Carousel autoPlay infiniteLoop itemsToShow={1} showThumbs={false} interval={3000} >
							{qbsmomentsslide}
						</Carousel>}
					</div>
				</div>
				<div className="col-md-3">

					<div className="dash_white_box mb20 mh426 talk_clientfeedback_wrp">
						<i className="icon icon-bubbles dash_bubbles_icon"></i>
						<div className="dash_white_box_ttl">Client Feedback</div>
						<div className="tips_wrp">
							<div className="tips_blk">
								{client_feedback.length && <Carousel autoPlay infiniteLoop itemsToShow={1} showThumbs={false} interval={3000}>
									{client_feedback}
								</Carousel>}

							</div>
						</div>
						<div className="dash_white_box_ttl">QBS Connect Talk</div>
						<div className="tips_wrp">
							<div className="tips_blk">
								{talks.length && <Carousel autoPlay infiniteLoop itemsToShow={1} showThumbs={false} interval={3000} indicators={false} >
									{talks}
								</Carousel>}

							</div>
						</div>


						<div className="dash_white_box_ttl mt05 mb00">Events
							<span className="events_date float-end">{EventDate}</span>
						</div>
						<div className="events_wrp">
							<div className="events_blk event_new_style">
								<div className="events_ttl">
									{userEvent.length > 0 ? userEvent : <div className="text-center nofound_wrp">
										<img crossOrigin="anonymous" src="assets/images/nofound1.png" />
									</div>}
									{/* <a href="#" className="dash_arrow float-end"><i className="icon icon-chevron-right"></i></a> */}
								</div>
							</div>
						</div>

						{/* <div className="dash_birthday_wrp">
							<div className="dash_birthday_blk">
								<i className="icon icon-chevron-left"></i>
							</div>
							<div className="dash_birthday_blk ">
								<img src="assets/images/1.png" />
								<img src="assets/images/2.png" />
								<img src="assets/images/3.png" />
								<img src="assets/images/4.png" />
								<img src="assets/images/5.png" />
								<img src="assets/images/1.png" />
							</div>
							<div className="dash_birthday_blk">
								<i className="icon icon-chevron-right"></i>
							</div>
						</div> */}
					</div>
				</div>
				<div className="col-md-3">
					<div className="calContainer">
						<div className="controls">
							<h2><i className="mr05 icon icon-calendar-full"></i><span id="headerText"></span></h2>
							<div className="buttons">
								<button onClick={onPrev} ><i className="icon icon-chevron-left"></i></button>
								<button onClick={onToday}>today</button>
								<button onClick={onNext}><i className="icon icon-chevron-right"></i></button>
							</div>
						</div>
						<div id="calendar"></div>
					</div>
					<div className="dash_white_box mb20 h155" style={{ minHeight: "186px" }}>

						<i className="fa fa-calendar dash_calendar_icon"></i>
						<div className="dash_white_box_ttl">Today's Birthday !</div>
						<div className="birthday_wrapper pt20">
							<div className="birthday_block pb00">
								{userbirthday?.map((items, index) => {
									{ var userImg = items.img ? SERVER_URL + 'dashboards/' + items.img : BASE_URL + 'assets/images/user_icon.png' }
									return (
										<div key={index} className="birthday-item">
											<img src={userImg} alt="" />
											<div className="employe_name">{items.name}</div>
											<div className="employe_post">{items.role_name}</div>
										</div>
									)

								})}
								{userbirthday.length < 1 ? <div className="text-center nofound_wrp">
									<img crossOrigin="anonymous" src="assets/images/nobirthday.png" />
								</div> : ''}
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-3">
					<div className="dash_white_box1 mb20 pb30 mh426">
						<div className="dash_white_box_ttl1">Facebook </div>
						<span className="dash_linkendin_icon"><i className="fa fa-facebook"></i></span>
						{qbsmomentsslide.length && <Carousel infiniteLoop itemsToShow={1} showThumbs={false} interval={3000} >
							<div className="dash_linkedin_wrp">
								<div className="dash_linkedin_img mb03">
									<div className='post_detail post_detail1'>
										<img crossOrigin="anonymous" src="assets/images/post.jpg" />
									</div>
									<div className='post_content'>
										<span>Q2A Media Services Pvt. Ltd.</span>
										<span>March 25</span>
									</div>
								</div>
								<div className="dash_linkedin_blk">
									<p className="mb10">
										As the vibrant hues of Holi spread joy and warmth, we extend our heartfelt wishes to you and your loved ones.
									</p>
									<div className="row">
										<div className="col-md-12">
											<img className="h228" crossOrigin="anonymous" src="assets/images/post8.jpg" />
										</div>
									</div>
								</div>
							</div>
							<div className="dash_linkedin_wrp">
								<div className="dash_linkedin_img mb03">
									<div className='post_detail post_detail1'>
										<img crossOrigin="anonymous" src="assets/images/post.jpg" />
									</div>
									<div className='post_content'>
										<span>Q2A Media Services Pvt. Ltd.</span>
										<span>February 23</span>
									</div>
								</div>
								<div className="dash_linkedin_blk">
									<p className="mb10">
										QBS Learning specializes in Workforce Skills, offering comprehensive services for training providers, employers, and employees.
									</p>
									<div className="row">
										<div className="col-md-12">
											<img className="h228" crossOrigin="anonymous" src="assets/images/post9.jpg" />
										</div>
									</div>
								</div>
							</div>
							<div className="dash_linkedin_wrp">
								<div className="dash_linkedin_img mb03">
									<div className='post_detail post_detail1'>
										<img crossOrigin="anonymous" src="assets/images/post.jpg" />
									</div>
									<div className='post_content'>
										<span>Q2A Media Services Pvt. Ltd.</span>
										<span>January 24</span>
									</div>
								</div>
								<div className="dash_linkedin_blk">
									<p className="mb10">
										Time is money, and QBS Echo saves you both. QBS Echo supports an extensive array of file formats – Word, PDF, IDML, and XML.
									</p>
									<div className="row">
										<div className="col-md-12">
											<img className="h228" crossOrigin="anonymous" src="assets/images/post10.jpg" />
										</div>
									</div>
								</div>
							</div>
						</Carousel>}

					</div>

				</div>
			</div>
		</div>
	)
}

export default DashboardComp;
